// extracted by mini-css-extract-plugin
export default {"blockMessage":"BlockMessage-module__[local]___N72fh"};